import { render, staticRenderFns } from "./tagAudit.vue?vue&type=template&id=2aabf818&scoped=true&"
import script from "./tagAudit.vue?vue&type=script&lang=js&"
export * from "./tagAudit.vue?vue&type=script&lang=js&"
import style0 from "./tagAudit.vue?vue&type=style&index=0&id=2aabf818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabf818",
  null
  
)

component.options.__file = "tagAudit.vue"
export default component.exports